import { useGetMailMessageByIdQuery } from "../../../services/useremails";
import { usePersonalOutlookContext } from "../../../hooks/PersonalOutlookContext";
import { useParams } from "react-router-dom";

const useEmail = (mailId) => {
    const { folderId } = useParams();
    const { selectedMailUserId: userId, searchTerm } = usePersonalOutlookContext();
    const { data, isLoading, isFetching, isError, error, refetch } = useGetMailMessageByIdQuery({ userId, folderId, mailId, searchTerm });

    const reload = (e) => {
        if (e && typeof (e.preventDefault)) {
            e.preventDefault();
        }
        refetch();
    };

    return {
        data: data || {},
        isLoading: isLoading || isFetching,
        isError,
        error,
        reload
    };
};

export default useEmail;